import React, { Component }                        from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";
import { FontAwesomeIcon }                         from '@fortawesome/react-fontawesome'
import "../../css/assessment/AssessmentNewDropdownMenu.css";

export default class AddNewAssessmentDropdownMenu extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <span style={{ position:"relative", right: 32}}>
                <ButtonToolbar className = "dropdownBtnAddNewAssessment pull-right" style={{ position:"relative", top:0}}>
                  <DropdownButton
                    bsStyle="default"
                    title="Add New Assessment"
                    noCaret
                    pullRight
                    id="dropdown-no-caret"
                    className="dropdownBtnAddNewAssessment"
                    >
                      <MenuItem //href="/assessment/new"
                                onSelect={this.props.handleProgram(1)}
                                eventKey="1"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="edit" className="modalBasicsTitleIcon" />
                            </span>
                            Free-form Assessment
                      </MenuItem>
                      <MenuItem //href="/assessment/ExerciseNewMultiple"
                                onSelect={this.props.handleProgram(2)}
                                eventKey="2"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="child" className="modalBasicsTitleIcon" />
                            </span>
                            In-Body Assessment
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(3)}
                                eventKey="3"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="weight" className="modalBasicsTitleIcon" />
                            </span>
                            Functional Movement
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(4)}
                                eventKey="4"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="heart" className="modalBasicsTitleIcon" />
                            </span>
                            Heart and Blood Check
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(5)}
                                eventKey="5"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="shoe-prints" className="modalBasicsTitleIcon" />
                            </span>
                            Lower Body Power
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(6)}
                                eventKey="6"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="align-left" className="modalBasicsTitleIcon" />
                            </span>
                            PAR-Q Assessment
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(7)}
                                eventKey="7"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="paste" className="modalBasicsTitleIcon" />
                            </span>
                            Primal Movement Patterns
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(8)}
                                eventKey="8"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="dumbbell" className="modalBasicsTitleIcon" />
                            </span>
                            Strength Assessment
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(9)}
                                eventKey="9"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="ruler-combined" className="modalBasicsTitleIcon" />
                            </span>
                            Joint Range of Motion
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(10)}
                                eventKey="10"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="hiking" className="modalBasicsTitleIcon" />
                            </span>
                            Spinal Range of Motion
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(11)}
                                eventKey="11"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="male" className="modalBasicsTitleIcon" />
                            </span>
                            Body Composition
                      </MenuItem>
                      <MenuItem onSelect={this.props.handleProgram(12)}
                                eventKey="12"
                                className="newAssessmentDropdownMenuItem">
                            <span className="dropdownAssessmentFontHolder">
                                <FontAwesomeIcon icon="ruler" className="modalBasicsTitleIcon" />
                            </span>
                            Girth Measurement
                      </MenuItem>
                  </DropdownButton>
                </ButtonToolbar>
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/AddNewAssessmentDropdownMenu.js